import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Tooltip, Typography } from '@mui/material';
import { FaTrash, FaEdit, FaPlus } from 'react-icons/fa'; // Import the FaPlus icon
import { format } from 'date-fns'; // Import date-fns for date formatting
import { useNavigate } from 'react-router-dom'; // Import useNavigate for routing

const PatientsTable = ({ patients, onEdit, onDelete }) => {
    const navigate = useNavigate(); // Initialize navigate hook

    const formatBirthday = (birthday) => {
        return birthday ? format(new Date(birthday), 'dd.MM.yyyy') : 'N/A'; // Format birthday as dd.MM.yyyy
    };

    const handleViewRecordsClick = (patientId) => {
        if (patientId) {
            navigate(`/patients/${patientId}/records`); // Navigate to patient records page
        }
    };

    return (
        <div className={'container'}>
            <TableContainer component={Paper} sx={{ boxShadow: 3, borderRadius: 1 }}>
                <Table sx={{ minWidth: 650 }} aria-label="patients table">
                    <TableHead>
                        <TableRow sx={{ backgroundColor: '#449998' }}>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>First Name</TableCell>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Last Name</TableCell>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>ID Number</TableCell>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Phone</TableCell>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Email</TableCell>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Birthday</TableCell>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Address</TableCell>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold', textAlign: 'center' }}>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {patients.length > 0 ? patients.map((patient) => (
                            <TableRow
                                key={patient.id}
                                sx={{
                                    '&:nth-of-type(odd)': { backgroundColor: '#f5f5f5' },
                                    '&:hover': { backgroundColor: 'rgba(68,153,152,0.09)', cursor: 'pointer' },
                                }}
                            >
                                <TableCell>{patient.name}</TableCell>
                                <TableCell>{patient.lastname}</TableCell>
                                <TableCell>{patient.id_number}</TableCell>
                                <TableCell>{patient.phone}</TableCell>
                                <TableCell>{patient.email}</TableCell>
                                <TableCell>{formatBirthday(patient.birthday)}</TableCell>
                                <TableCell>{patient.address || 'N/A'}</TableCell>
                                <TableCell align="center">
                                    {/* Add the "+" icon for viewing patient records */}
                                    <Tooltip title="View Patient Records" placement="top">
                                        <IconButton
                                            color="primary"
                                            onClick={() => handleViewRecordsClick(patient.id)} // Handle view records click
                                        >
                                            <FaPlus />
                                        </IconButton>
                                    </Tooltip>

                                    {/* Existing Edit icon */}
                                    <Tooltip title="Edit Patient" placement="top">
                                        <IconButton color="primary" onClick={() => onEdit(patient)}>
                                            <FaEdit />
                                        </IconButton>
                                    </Tooltip>

                                    {/* Existing Delete icon */}
                                    <Tooltip title="Delete Patient" placement="top">
                                        <IconButton color="secondary" onClick={() => onDelete(patient)}>
                                            <FaTrash />
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        )) : (
                            <TableRow>
                                <TableCell colSpan={8} align="center">
                                    <Typography variant="body1" color="textSecondary">No patients found</Typography>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
};

export default PatientsTable;
